(function(){
gsap.registerPlugin(ScrollTrigger);
var spRoot = document.querySelector('.sp-root');

/* CURSOR */
var dot = spRoot.querySelector('.sp-cursor-dot');
var ring = spRoot.querySelector('.sp-cursor-ring');
var mx=0,my=0,rx=0,ry=0;
window.addEventListener('mousemove', function(e){
  mx=e.clientX; my=e.clientY;
  dot.style.left=mx+'px'; dot.style.top=my+'px';
});
gsap.ticker.add(function(){
  rx += (mx-rx)*0.15; ry += (my-ry)*0.15;
  ring.style.left=rx+'px'; ring.style.top=ry+'px';
});
spRoot.querySelectorAll('a,button,.sp-pressure-pt,.sp-map-item,.sp-product-card,.sp-g-item').forEach(function(el){
  el.addEventListener('mouseenter',function(){ring.classList.add('sp-grow');});
  el.addEventListener('mouseleave',function(){ring.classList.remove('sp-grow');});
});

/* LOADER */
(function loader(){
  var canvas = document.getElementById('sp-loader-canvas');
  if(!canvas) return;
  var ctx = canvas.getContext('2d');
  var W = canvas.width, H = canvas.height;
  var targets = [];
  var outline = [[90,20],[100,26],[108,36],[112,50],[110,64],[103,76],[112,92],[118,110],[118,134],[110,150],[100,158],[90,158],[80,150],[72,134],[72,110],[78,92],[87,76],[80,64],[78,50],[82,36]];
  outline.forEach(function(p){targets.push({x:p[0],y:p[1]});});
  [[90,45],[76,62],[104,62],[90,95],[90,128]].forEach(function(p){targets.push({x:p[0],y:p[1],pt:true});});
  var dots = targets.map(function(t){return {x:Math.random()*W,y:Math.random()*H,tx:t.x+(W/2-90),ty:t.y+(H/2-90),pt:t.pt};});
  var progress = 0;
  function draw(){
    ctx.clearRect(0,0,W,H);
    dots.forEach(function(d){
      var cx = d.x + (d.tx-d.x)*progress;
      var cy = d.y + (d.ty-d.y)*progress;
      ctx.beginPath();
      ctx.arc(cx,cy, d.pt?4:2.6, 0, Math.PI*2);
      ctx.fillStyle = d.pt ? '#A96F65' : 'rgba(91,68,56,'+(0.5+progress*0.4)+')';
      ctx.fill();
    });
  }
  function animate(){
    progress = Math.min(1, progress+0.018);
    draw();
    if(progress<1) requestAnimationFrame(animate);
  }
  animate();
  var done = false;
  function finish(){
    if(done) return; done = true;
    gsap.to('#sp-loader-canvas',{opacity:0,scale:1.3,duration:.6,ease:'power2.out'});
    gsap.to('.sp-loader-word',{opacity:0,duration:.5});
    gsap.to('#sp-loader',{opacity:0,duration:.8,delay:.35,ease:'power2.inOut',onComplete:function(){
      document.getElementById('sp-loader').style.display='none';
      introTimeline();
    }});
  }
  if(document.readyState === 'complete'){ setTimeout(finish, 900); }
  else { window.addEventListener('load', function(){ setTimeout(finish, 900); }); }
})();

/* NAV SCROLL STATE */
var navEl = document.getElementById('sp-nav');
if(navEl){
  ScrollTrigger.create({
    start: 60, end: 99999,
    onUpdate: function(self){ navEl.classList.toggle('sp-scrolled', self.scroll()>60); }
  });
}

/* HERO TEXT SPLIT */
spRoot.querySelectorAll('[data-sp-line]').forEach(function(line){
  var words = line.textContent.split(' ');
  line.innerHTML = words.map(function(w){return '<span style="display:inline-block;overflow:hidden;"><span style="display:inline-block;">'+w+'&nbsp;</span></span>';}).join('');
});

function introTimeline(){
  var tl = gsap.timeline({defaults:{ease:'power4.out'}});
  tl.to('.sp-hero-eyebrow', {opacity:1, duration:.01})
    .from('.sp-hero-eyebrow', {y:20, opacity:0, duration:.7})
    .to('.sp-hero h1 [data-sp-line] span span', {y:0, duration:1.1, stagger:0.05}, '-=.4')
    .to('.sp-hero-sub', {opacity:1, y:0, duration:.9}, '-=.6')
    .from('.sp-hero .sp-btn', {opacity:0, y:16, duration:.7}, '-=.5')
    .from('.sp-scroll-cue', {opacity:0, duration:.6}, '-=.4');
}

/* REVEAL ON SCROLL */
spRoot.querySelectorAll('.sp-reveal').forEach(function(el){
  gsap.fromTo(el, {opacity:0,y:40},{
    opacity:1,y:0,duration:1,ease:'power3.out',
    scrollTrigger:{trigger:el, start:'top 85%'}
  });
});

/* STORY CHAPTERS */
gsap.utils.toArray('.sp-chapter').forEach(function(ch){
  gsap.fromTo(ch.querySelectorAll('.sp-chapter-num, h3, p'), {opacity:0,y:60},
    {opacity:1,y:0,duration:1,stagger:.08,ease:'power3.out',
     scrollTrigger:{trigger:ch, start:'top 65%'}});
});

/* PRODUCT CARD TILT (skip on touch) */
if(!matchMedia('(hover:none)').matches){
  spRoot.querySelectorAll('.sp-product-card').forEach(function(card){
    card.addEventListener('mousemove', function(e){
      var r = card.getBoundingClientRect();
      var px = (e.clientX-r.left)/r.width - .5;
      var py = (e.clientY-r.top)/r.height - .5;
      gsap.to(card, {rotateY: px*10, rotateX: -py*10, duration:.4, ease:'power2.out', transformPerspective:700});
    });
    card.addEventListener('mouseleave', function(){gsap.to(card,{rotateX:0,rotateY:0,duration:.6,ease:'power3.out'});});
  });
}

/* REFLEXOLOGY MAP */
var pts = spRoot.querySelectorAll('.sp-pressure-pt');
var items = spRoot.querySelectorAll('.sp-map-item');
function setActive(target){
  pts.forEach(function(p){p.classList.toggle('sp-active', p.dataset.spTarget===target);});
  items.forEach(function(i){i.classList.toggle('sp-active', i.dataset.spTarget===target);});
}
pts.forEach(function(p){
  p.addEventListener('mouseenter', function(){setActive(p.dataset.spTarget);});
  p.addEventListener('click', function(){setActive(p.dataset.spTarget);});
  gsap.to(p, {attr:{r:7}, duration:1.2, repeat:-1, yoyo:true, ease:'sine.inOut', delay:Math.random()});
});
items.forEach(function(i){
  i.addEventListener('mouseenter', function(){setActive(i.dataset.spTarget);});
  i.addEventListener('click', function(){setActive(i.dataset.spTarget);});
});

/* REAL ADD TO CART */
function spUpdateCartCount(){
  fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
    spRoot.querySelectorAll('.sp-cart-count').forEach(function(el){ el.textContent = cart.item_count; });
  }).catch(function(){});
}
spRoot.querySelectorAll('.sp-add-to-cart').forEach(function(btn){
  btn.addEventListener('click', function(){
    var id = btn.dataset.variantId;
    if(!id) return;
    var original = btn.textContent;
    btn.textContent = 'Adding…'; btn.disabled = true;
    fetch('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({items:[{id:id, quantity:1}]})
    }).then(function(res){
      if(!res.ok) throw new Error('add failed');
      btn.textContent = 'Added ✓';
      spUpdateCartCount();
      setTimeout(function(){btn.textContent = original; btn.disabled=false;}, 1600);
    }).catch(function(){
      btn.textContent = 'Try again'; btn.disabled=false;
    });
  });
});
spUpdateCartCount();

/* HERO THREE.JS SCENE */
(function heroScene(){
  var canvas = document.getElementById('sp-hero-canvas');
  if(!canvas || typeof THREE === 'undefined') return;
  var renderer = new THREE.WebGLRenderer({canvas:canvas, alpha:true, antialias:true});
  renderer.setPixelRatio(Math.min(devicePixelRatio,2));
  var scene = new THREE.Scene();
  var camera = new THREE.PerspectiveCamera(45, innerWidth/innerHeight, .1, 100);
  camera.position.set(0,0,9);
  function resize(){
    renderer.setSize(canvas.clientWidth, canvas.clientHeight);
    camera.aspect = canvas.clientWidth/canvas.clientHeight;
    camera.updateProjectionMatrix();
  }
  window.addEventListener('resize', resize);
  resize();

  function sockOutlinePoint(t){
    var legTop=-2.6, legBottom=0.2, legW=0.95;
    if(t < 0.35){ var u=t/0.35; return {x:legW, y:legTop+(legBottom-legTop)*u}; }
    else if(t < 0.55){ var u=(t-0.35)/0.2; var ang=u*Math.PI*0.55; return {x:legW*Math.cos(ang)+0.15, y:legBottom+Math.sin(ang)*1.3}; }
    else if(t < 0.7){ var u=(t-0.55)/0.15; var ang=Math.PI*0.55+u*Math.PI*0.5; return {x:0.9*Math.cos(ang)+0.15, y:legBottom+1.3+0.35*Math.sin(ang)}; }
    else if(t < 0.85){ var u=(t-0.7)/0.15; return {x:(0.15-0.55)+(1-u)*(0.55-(-legW)), y:legBottom+1.55}; }
    else { var u=(t-0.85)/0.15; var heelTopY=legBottom+1.55; return {x:-legW, y:heelTopY+(legTop-heelTopY)*u}; }
  }

  var COUNT = window.innerWidth < 768 ? 1200 : 2600;
  var positions = new Float32Array(COUNT*3);
  for(var i=0;i<COUNT;i++){
    var t = Math.random();
    var p = sockOutlinePoint(t);
    var jitter = 0.12;
    var x = p.x*(0.75+Math.random()*0.3) + (Math.random()-0.5)*jitter;
    var y = p.y + (Math.random()-0.5)*jitter;
    var z = (Math.random()-0.5)*0.9;
    positions[i*3]=x; positions[i*3+1]=y; positions[i*3+2]=z;
  }
  var geo = new THREE.BufferGeometry();
  geo.setAttribute('position', new THREE.BufferAttribute(positions,3));

  var sprite = (function(){
    var c = document.createElement('canvas'); c.width=c.height=64;
    var g = c.getContext('2d');
    var grad = g.createRadialGradient(32,32,0,32,32,32);
    grad.addColorStop(0,'rgba(198,140,130,1)');
    grad.addColorStop(1,'rgba(198,140,130,0)');
    g.fillStyle=grad; g.fillRect(0,0,64,64);
    return new THREE.CanvasTexture(c);
  })();

  var mat = new THREE.PointsMaterial({size:0.055, map:sprite, transparent:true, depthWrite:false, blending:THREE.AdditiveBlending, color:new THREE.Color('#C68C82')});
  var points = new THREE.Points(geo, mat);
  points.scale.set(1.9,1.9,1.9);
  points.position.y = -0.3;
  scene.add(points);

  var glowGeo = new THREE.BufferGeometry();
  var glowPos = [];
  for(var i=0;i<6;i++){
    var t = i/6;
    var p = sockOutlinePoint(0.2+t*0.5);
    glowPos.push(p.x*0.5,p.y*0.6,0.1);
  }
  glowGeo.setAttribute('position', new THREE.Float32BufferAttribute(glowPos,3));
  var glowMat = new THREE.PointsMaterial({size:0.22, map:sprite, transparent:true, depthWrite:false, blending:THREE.AdditiveBlending, color:new THREE.Color('#A96F65')});
  var glowPoints = new THREE.Points(glowGeo, glowMat);
  glowPoints.scale.set(1.9,1.9,1.9);
  glowPoints.position.y=-0.3;
  scene.add(glowPoints);

  var mouseX=0, mouseY=0;
  window.addEventListener('mousemove', function(e){
    mouseX = (e.clientX/innerWidth - .5);
    mouseY = (e.clientY/innerHeight - .5);
  });

  var clock = new THREE.Clock();
  function tick(){
    var t = clock.getElapsedTime();
    points.rotation.y = Math.sin(t*0.15)*0.35 + mouseX*0.4;
    points.rotation.x = mouseY*0.15;
    glowPoints.rotation.copy(points.rotation);
    glowMat.opacity = 0.6 + Math.sin(t*2)*0.35;
    camera.position.x += (mouseX*0.6 - camera.position.x)*0.02;
    camera.lookAt(0,0,0);
    renderer.render(scene,camera);
    requestAnimationFrame(tick);
  }
  tick();

  var heroEl = spRoot.querySelector('.sp-hero');
  if(heroEl){
    ScrollTrigger.create({
      trigger:heroEl, start:'top top', end:'bottom top', scrub:1,
      onUpdate: function(self){ camera.position.z = 9 - self.progress*2.4; points.rotation.z = self.progress*0.3; }
    });
  }
})();

/* FOOTER PARTICLES */
(function footerParticles(){
  var canvas = document.getElementById('sp-footer-canvas');
  if(!canvas) return;
  var ctx = canvas.getContext('2d');
  function resize(){ canvas.width = canvas.clientWidth; canvas.height = canvas.clientHeight; }
  window.addEventListener('resize', resize); resize();
  var N = 40;
  var parts = [];
  for(var i=0;i<N;i++){
    parts.push({x:Math.random()*canvas.width, y:Math.random()*canvas.height, r:Math.random()*2+0.6, s:Math.random()*0.3+0.05, o:Math.random()*0.4+0.1});
  }
  function draw(){
    ctx.clearRect(0,0,canvas.width,canvas.height);
    parts.forEach(function(p){
      p.y -= p.s;
      if(p.y<-10){p.y=canvas.height+10; p.x=Math.random()*canvas.width;}
      ctx.beginPath();
      ctx.arc(p.x,p.y,p.r,0,Math.PI*2);
      ctx.fillStyle = 'rgba(230,196,180,'+p.o+')';
      ctx.fill();
    });
    requestAnimationFrame(draw);
  }
  draw();
})();

/* MOBILE MENU */
var menuBtn = spRoot.querySelector('.sp-menu-btn');
var navLinksEl = spRoot.querySelector('.sp-nav-links');
if(menuBtn && navLinksEl){
  menuBtn.addEventListener('click', function(){
    var open = menuBtn.classList.toggle('sp-open');
    navLinksEl.classList.toggle('sp-mobile-open');
    menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  navLinksEl.querySelectorAll('a').forEach(function(a){
    a.addEventListener('click', function(){
      menuBtn.classList.remove('sp-open');
      navLinksEl.classList.remove('sp-mobile-open');
      menuBtn.setAttribute('aria-expanded','false');
    });
  });
}

setTimeout(function(){ ScrollTrigger.refresh(); }, 1200);
})();